var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerybigFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 90,
    viewBox: "0 0 115 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 73.567L53.0316 17.5009C53.7763 16.833 54.9045 16.833 55.6494 17.5009L74.9747 45.1385V31.3744C74.9747 30.2915 75.8527 29.4136 76.9355 29.4136H90.0022C91.0849 29.4136 91.9629 30.2915 91.9629 31.3744V60.3705L106.681 73.567",
    stroke: "#FF0000",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerybigFace);
export default __webpack_public_path__ + "static/media/verybigFace.516d5c365eb0c38f7010c3aa06987f94.svg";
export { ForwardRef as ReactComponent };